export const SOCIAL_LINKS = {
  instagram: "https://www.instagram.com/mira_mirror.ai/",
  tiktok: "https://www.tiktok.com/@mira.mirror.style",
  pinterest: "https://www.pinterest.com/miramirrorai/",
  facebook: "https://www.facebook.com/profile.php?id=1411300028725929",
  youtube: "https://www.youtube.com/@MIRAMIRROR-AISTYLINGCOACH",
  x: "https://x.com/Mira_Mirror_ai",
  linkedin: "https://www.linkedin.com/company/mira-mirror-ai-styling-coach/",
};
